import { render, staticRenderFns } from "./PrizesList.vue?vue&type=template&id=4f57c5ad"
import script from "./PrizesList.vue?vue&type=script&lang=js"
export * from "./PrizesList.vue?vue&type=script&lang=js"
import style0 from "./PrizesList.vue?vue&type=style&index=0&id=4f57c5ad&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports